export class DependentsData {
    private dependentsList: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9 over'];

    public getDependentsList(): Array<string> {
        return this.dependentsList;
    }
}